import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function ConfirmDialog(props) {
	const open = props.open ? true : false;
	const title = props.title ? props.title : "";
	const message = props.message ? props.message : "";
	const captionYes = props.captionYes ? props.captionYes : "Ja";
	const captionNo = props.captionNo ? props.captionNo : "Nein";
	const handleYes = props.handleYes ? props.handleYes : () => {};
	const handleNo = props.handleNo ? props.handleNo : () => {};

	return (
		<div>
			<Dialog
				open={open}
				onClose={(event, reason) => {
					if (reason !== 'backdropClick') {
							onClose(event, reason)
					}
				}}
				disableEscapeKeyDown
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleNo}
						variant="outlined"
						color="primary"
						size="small">
						{captionNo}
					</Button>
					<Button
						onClick={handleYes}
						variant="outlined"
						color="primary"
						autoFocus
						size="small"
					>
						{captionYes}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
